import React from 'react';
import ExerciseList from './ExerciseList';
import WorkoutContainer from './WorkoutContainer';

const TypeContent = ({ 
  tab, 
  workouts, 
  exercises, 
  programName,
  onRemoveExercise, 
  onExerciseMoveUp,
  onExerciseMoveDown,
  onSwitchExercise,
  onClickSuperset,
  onRemoveExerciseFromSuperset,
  onRemoveWorkout 
}) => {
  return (
    <div className="flex bg-gray-50 rounded-lg overflow-hidden" style={{ minHeight: '400px' }}>
      <ExerciseList 
        exercises={exercises}
        onRemoveExercise={onRemoveExercise}
        onExerciseMoveUp={onExerciseMoveUp} 
        onExerciseMoveDown={onExerciseMoveDown}
        onSwitchExercise={onSwitchExercise}
        onClickSuperset={onClickSuperset}
        onRemoveExerciseFromSuperset={onRemoveExerciseFromSuperset}
      />
      
      <WorkoutContainer
        tabId={tab.id}
        tabLabel={tab.label}
        workouts={workouts}
        programName={programName}
        onRemoveWorkout={onRemoveWorkout}
      />
    </div>
  );
};

export default TypeContent;